<template>
  <div>
    <div>
      <div class="card">
        <div class="card-body">
          <div class="d-flex with-media">
            <div class="p-2 w-100">
              <div class="media">
                <img src="/static/img/test@2x.png"/>
                <div class="media-body">
                  <h5>{{examInfo.title}}</h5>
                  <div>
                    <span class="gray">유형</span> {{examInfo.exam_type_name}}
                    · <span class="gray">응시인원 </span> <span class="number">{{examInfo.entry_cnt}}</span>
                    · <span class="gray">공개일</span> {{this.formatterDate(examInfo.open_dt)}}
                    · <span class="gray">카테고리</span> {{examInfo.cate_path}}
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="p-2 ml-auto button-group">
              <button type="button" class="btn btn-secondary" @click="handleCommand('download')">PDF 저장</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card second-card">
        <div class="card-body el-tabs__content">
          <div class="d-flex">
            <div class="p-2">
              <h2>성적분포</h2>
            </div>
          </div>

          <div class="d-flex blue-gray">
            <div class="p-2">
              <h1>{{examInfo.title}}</h1>
              <p>
                <span class="gray">전체평균</span> <span class="number">{{examInfo.avg_score}}</span>
                · <span class="gray">최고점수</span> <span class="number">{{examInfo.exam_score_max}}</span>
                · <span class="gray">최저점수</span> <span class="number">{{examInfo.exam_score_min}}</span>
              </p>
            </div>
          </div>

          <el-row :gutter="40">
            <el-col :span="12">
              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                  <h2>성적 분석</h2>
                  </div>
                </div>
                <!-- 그리드 -->
                <stone-data-table
                  :loading="searchLoading"
                  :columns="tableColumns"
                  :data="tableData"
                  :table-props="tableProps"
                  :page-size="emptyPageSize"
                  :pagination-props="emptyPaginationProps">
                </stone-data-table>
              </fieldset>
            </el-col>
            <el-col :span="12" ref="chart">
              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>성적 분포도</h2>
                  </div>
                  <div class="p-2 ml-auto">
                    <img src="/static/img/mint-circle.svg" /> 인원수
                  </div>
                </div>
                <bar-chart :chart-data="chartData1" :height="chartHeight" :options="chartOptions" :styles="chartStyles"></bar-chart>
              </fieldset>
              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>성적 분포도</h2>
                  </div>
                </div>
              <doughnut-chart :chart-data="chartData2" :height="chartHeight" :options="chartOptions2" :styles="chartStyles"></doughnut-chart>
              </fieldset>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- PDF Dialog-->
    <el-dialog title="성적 분포" width="1200px" :visible.sync="dialogTableVisible" append-to-body>
      <div class="pdf-file">
        <div class="card-body text-right">
          <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fas fa-file-pdf"></i></el-button>
        </div>
        <div class="print-grade-read-times">
          <div class="card">
            <div class="card-body">
              <div class="media logo">
                <img src="/static/img/logo_notext.png" />
                <div class="media-body">
                  <h2>성적 분포</h2>
                </div>
              </div>
              <div class="d-flex with-media">
                <div class="p-2 w-100">
                  <div class="media">
                    <img src="/static/img/test@2x.png"/>
                    <div class="media-body">
                      <h5>{{examInfo.title}}</h5>
                      <div>
                        <span class="gray">유형</span> {{examInfo.exam_type_name}}
                        · <span class="gray">응시인원 </span> <span class="number">{{examInfo.entry_cnt}}</span>
                        · <span class="gray">공개일</span> {{formatterDate(examInfo.open_dt)}}
                        · <span class="gray">카테고리</span> {{examInfo.cate_path}}
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card second-card">
            <div class="card-body el-tabs__content">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1>{{examInfo.title}}</h1>
                  <p>
                    <span class="gray">전체평균</span> <span class="number">{{examInfo.avg_score}}</span>
                    · <span class="gray">최고점수</span> <span class="number">{{examInfo.exam_score_max}}</span>
                    · <span class="gray">최저점수</span> <span class="number">{{examInfo.exam_score_min}}</span>
                  </p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                      <h2>성적 분석</h2>
                      </div>
                    </div>
                    <!-- 그리드 -->
                    <stone-data-table
                      :loading="searchLoading"
                      :columns="tableColumns"
                      :data="tableData"
                      :table-props="tableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table>
                  </fieldset>
                </el-col>
                <el-col :span="12" ref="chart">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분포도</h2>
                      </div>
                      <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 인원수
                      </div>
                    </div>
                    <bar-chart :chart-data="chartData1" :height="chartHeight" :options="chartOptions" :styles="chartStyles2"></bar-chart>
                  </fieldset>
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분포도</h2>
                      </div>
                    </div>
                  <doughnut-chart :chart-data="chartData2" :height="chartHeight" :options="chartOptions2" :styles="chartStyles2"></doughnut-chart>
                  </fieldset>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import common from '@/modules/common'
import BarChart from '@/components/chart/Bar.js'
import DoughnutChart from '@/components/chart/Doughnut.js'
import pdf from '@/modules/pdf'

export default {
  name: 'M070102',
  components: {BarChart, DoughnutChart},
  mixins: [common.mixins, pdf],
  data () {
    return {
      examInfo: {},
      tableProps: {showSummary: true, sumText: '합계', sortable: false, summaryMethod: this.getSummaries},
      tableData: [],
      tableColumns: [
        {label: '성취도', prop: 'title', align: 'center', class: 'number'},
        {label: '인원수', prop: 'rate_count', align: 'center', class: 'number'},
        {label: '비율', prop: 'result_rate', align: 'center', formatter: this.columnFormatterRate, class: 'number'},
        {label: '누적비율', prop: 'accumulate_result_rate', align: 'center', formatter: this.columnFormatterRate, class: 'number'}
      ],
      chartData1: [],
      chartData2: [],
      chartHeight: 420,
      chartHeight2: 415,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        cornerRadius: 6,
        legend: {display: false},
        scales: {
          yAxes: [
            {ticks: {min: 0}}
          ],
          xAxes: [
            {gridLines: {display: false}}
          ]
        }
      },
      chartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          angleLines: {display: false}
        },
        legend: {
          position: 'right',
          padding: 20
        }
      },
      pdfLoading: false,
      dialogTableVisible: false
    }
  },
  beforeCreate () {
  },
  created () {
    if (this.$route.params) {
      this.loadInfo(this.$route.params.exam_seq)
    } else {
      this.$router.push({name: 'M070101'})
    }
  },
  computed: {
    chartStyles () {
      return {
        height: `${this.chartHeight}px`,
        position: 'relative'
      }
    },
    chartStyles2 () {
      return {
        height: `${this.chartHeight2}px`,
        position: 'relative'
      }
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo (examSeq) {
      common.axios.get('/stats/exam/score/' + examSeq)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          this.examInfo = result.exam_score
          this.tableData = result.exam_rate
          this.chartData1 = this.getChartData1(result.exam_rate)
          this.chartData2 = this.getChartData2(result.exam_rate)
        })
    },
    getSummaries (param) {
      return this.getSummary(param, [2], '%')
    },
    getSummary (param, avg, subFix) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '합계'
          return
        } else if (index === 3) {
          sums[index] = '100%'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      avg.map(i => {
        sums[i] = parseFloat(sums[i]).toFixed(1) + subFix
      })
      return sums
    },
    getChartData1 (data) {
      const labels = []
      const datasets1 = []
      data.forEach(x => {
        labels.push(x.rate + '%')
        datasets1.push(x.rate_count)
      })
      const datasets = [
        {
          label: '인원수',
          backgroundColor: '#00aec0',
          data: datasets1
        }
      ]
      return {labels: labels, datasets: datasets}
    },
    getChartData2 (data) {
      const labels = []
      const datasets1 = []
      const value = [
        {group: 'A', title: '90-100%', total: 0},
        {group: 'B', title: '80-90% 미만', total: 0},
        {group: 'C', title: '70-80% 미만', total: 0},
        {group: 'D', title: '60-70% 미만', total: 0},
        {group: 'E', title: '50-60% 미만', total: 0},
        {group: 'F', title: '40-50% 미만', total: 0},
        {group: 'G', title: '40% 미만', total: 0}
      ]
      data.forEach(x => {
        value.some(g => {
          if (g.group === x.rate_group) {
            g.total += x.rate_count
            return true
          }
        })
      })
      value.forEach(x => {
        labels.push(x.title)
        datasets1.push(x.total)
      })
      const datasets = [
        {
          label: '',
          // backgroundColor: ['#646d90', '#8ca3b5', '#bac16b', '#ddc16b', '#a37464', '#7d655d', '#a2a7be'],
          backgroundColor: ['#D32F2F', '#512DA8', '#0288D1', '#388E3C', '#FBC02D', '#E64A19', '#455A64'],
          data: datasets1
        }
      ]
      return {labels: labels, datasets: datasets}
    },
    handleCommand (command) {
      if (command === 'refresh') {
        this.loadInfo(this.examInfo.exam_seq)
      } else if (command === 'download') {
        this.dialogTableVisible = true
        this.$nextTick(() => {
        })
      }
    },
    handlePDF () {
      this.makePDF('.print-grade-read-times')
    },
    makePDF (selector) {
      this.pdfLoading = true
      this.$nextTick(() => {
        this.exportPDF(selector, `성적 분포_${this.examInfo.title}`)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-tabs__nav {
    width: 100%;
  }
  .el-tabs__item {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M070102.vue